import { Types } from "../Constants/Types";
import WarehouseOpsType from "../Interfaces/warehouse-ops.interface";

const SortingReducer = (
  state: WarehouseOpsType["sortingState"] = {
    package: [],
    trackNumber: "",
    lpackage: false,
    lscan: false,
  },
  action: WarehouseOpsType["action"]
) => {
  switch (action.type) {
    case Types.FETCH_SORTING_PACKAGE:
      return {
        ...state,
        package: action.payload?.package ?? [],
        trackNumber: action.payload?.trackNumber ?? state.trackNumber,
      };

    case Types.RESET_SORTING_PACKAGE:
      return { ...state, package: [], trackNumber: "" };

    // Re-load the package list after a scan with fresh progress numbers.
    case Types.UPDATE_SORTING_PACKAGE:
      return { ...state, package: action.payload };

    case Types.START_SORTING_PACKAGE:
      return { ...state, lpackage: true };

    case Types.END_SORTING_PACKAGE:
      return { ...state, lpackage: false };

    case Types.START_SORTING_SCAN:
      return { ...state, lscan: true };

    case Types.END_SORTING_SCAN:
      return { ...state, lscan: false };

    default:
      return state;
  }
};

export default SortingReducer;
